import api from './api';

const formaEntregaService = {
  // Listar formas de entrega com paginação
  list: async (params = {}) => {
    try {
      const response = await api.get('/formaentrega', { params });
      return response.data;
    } catch (error) {
      console.error('Erro ao listar formas de entrega:', error);
      throw error;
    }
  },

  // Listar todas as formas ativas para selects
  getAll: async () => {
    try {
      const response = await api.get('/formaentrega/all');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar formas de entrega:', error);
      throw error;
    }
  },

  // Buscar forma por ID
  getById: async (id) => {
    try {
      const response = await api.get(`/formaentrega/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar forma de entrega:', error);
      throw error;
    }
  },

  // Criar nova forma
  create: async (data) => {
    try {
      const response = await api.post('/formaentrega', data);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar forma de entrega:', error);
      throw error;
    }
  },

  // Atualizar forma
  update: async (id, data) => {
    try {
      const response = await api.put(`/formaentrega/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar forma de entrega:', error);
      throw error;
    }
  },

  // Excluir forma
  delete: async (id) => {
    try {
      const response = await api.delete(`/formaentrega/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao excluir forma de entrega:', error);
      throw error;
    }
  }
};

// Exports nomeados para compatibilidade com componentes existentes
export const fetchFormaEntrega = formaEntregaService.list;
export const createFormaEntrega = formaEntregaService.create;
export const updateFormaEntrega = formaEntregaService.update;
export const deleteFormaEntrega = formaEntregaService.delete;

export default formaEntregaService;
